import React from 'react';
import CSSclasses from './colored-frame.scss';
const ColoredFrame = ({
  color
}) => /*#__PURE__*/React.createElement("div", {
  className: CSSclasses[color]
}, /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.top
}), /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.right
}), /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.bottom
}), /*#__PURE__*/React.createElement("div", {
  className: CSSclasses.left
}));
export default ColoredFrame;